import { gql } from "@apollo/client";

export const GET_COMMUNICATION_SETTINGS = gql`
    query GetCommunicationSettings {
        customer: ums_customers {
            id
            email
        }
    }
`;

export const UPDATE_COMMUNICATION_SETTINGS_GENERAL_EMAIL = gql`
    mutation UpdateCommunicationSettingsGeneralEmail($customerId: uuid!, $email: String!) {
        update_ums_customers(_set: { email: $email }, where: { id: { _eq: $customerId } }) {
            affected_rows
        }
    }
`;
